module.exports = __webpack_public_path__ + "static/media/Head2.b9e4d26c.svg";